import { DeployEnvironment, envConfig } from '@globals/env'

const validProductionDomains = [
  // Production domains -- NOTE these must match exactly
  /^weare\.kudos\.com$/,
  /^tenant\.kudos\.com$/,
  /^qacanary\.kudos\.com$/,
]

export const isDomainEnabled = () => {
  if (envConfig.DEPLOY_ENVIRONMENT !== DeployEnvironment.PRODUCTION) return true
  return validProductionDomains.some(domain => domain.test(window.location.hostname))
}
